import ResetPassword from './container'
import ResetPasswordDone from './reset_passwort_succeed'
export { ResetPassword, ResetPasswordDone }
export default ResetPassword